// extracted by mini-css-extract-plugin
export var closeButton = "_7c-0";